import React from 'react';
import ReactDOM from 'react-dom';
import App from './src/components/app';

const appRoot = document.getElementById('react-root');

ReactDOM.render(<App />, appRoot);